import React, { CSSProperties, memo, useContext } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import { ShareDataWrapperContext } from '../..';

export interface CardBoxProps {
  title?: React.ReactNode;
  children: React.ReactNode;
  extraContent?: React.ReactNode;
  style?: CSSProperties;
  showIcon?: boolean;
  className?: string;
}

const CardBox: React.FC<CardBoxProps> = props => {
  const { isStandardSize } = useContext(ShareDataWrapperContext);
  const { title, style, extraContent, className } = props;

  const showHeader = title || extraContent;

  return (
    <div className={`${styles.cardContainer} ${isStandardSize ? styles.standardCardContainer : ''}`} style={style}>
      {showHeader && (
        <div className={styles.headerWrapper}>
          {title ? <div className={styles.formTitle}>{title}</div> : <div />}
          {extraContent ? extraContent : <div />}
        </div>
      )}

      <div className={classNames(styles.content, className)}>{props.children}</div>
    </div>
  );
};

export default memo(CardBox);
